<template>
  <b-modal
    id="modalSaveCalculationProductionPartiallyRelieveLoad"
    v-model="localActive"
    centered
    hide-footer
    hide-header
    @show="onShowModal"
    @close="localActive = false"
  >
    <div class="m-completely-relieve-load">
      <svg
        class="m-completely-relieve-load-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-completely-relieve-load-title">Полностью освободить от нагрузки</div>
      <div class="m-completely-relieve-load-fullname">{{ record.employee.value }}</div>
      <div class="m-completely-relieve-load-description">
        Для сотрудника <b>{{ record.employee.value }}</b> будет полностью снята нагрузка за текущую смену. Сотрудник за
        отработанную смену получит только свою заработную плату без учёта коэффициентов: норматива, премирования,
        депремирования.
      </div>

      <div class="m-completely-relieve-load-actions">
        <c-button size="large" class="m-completely-relieve-load-actions-cancel" label="Отменить" @click="closeModal" />
        <c-button
          class="m-completely-relieve-load-actions-take-off-load"
          label="Снять нагрузку"
          color="blue"
          size="large"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Button from "@/components/controls/button";

export default {
  name: "m-completely-relieve-load",

  components: {
    "c-button": Button,
  },

  props: ["active", "record"],

  data() {
    return {
      localActive: false,
      salaryLocal: "",
      standardRatioLocal: "",
      bonusRateLocal: "",
      depreciationCoefficientLocal: "",
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
      }
    },
    active(value) {
      this.localActive = value;
    },
  },

  methods: {
    handleScroll(e) {
      this.scrolled = e.target.scrollTop > 0;
    },
    onShowModal() {
      this.salaryLocal = this.record.salary.value;
      this.standardRatioLocal = this.record.ratio_standart.value;
      this.bonusRateLocal = this.record.bonus_rate.value;
      this.depreciationCoefficientLocal = this.record.deprivation_coefficient.value;
    },
    closeModal() {
      this.localActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-completely-relieve-load {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
  }

  &-fullname {
    font-weight: 400;
    font-size: 18px;
    line-height: 120%;
  }

  &-description {
    margin-top: 19px;
    font-size: 13px;
    line-height: 140%;
  }

  &-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 40px;

    @media screen and (max-width: 700px) {
      width: 100%;
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-cancel {
      @media screen and (max-width: 700px) {
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }

    &-take-off-load {
      margin-left: 10px;

      @media screen and (max-width: 700px) {
        margin-left: 0;
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
